import ajax from './index'
import apiEnv from './apiEnv'

// 课程素材列表
export function matterList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/courseMedia/list`, data)
}
// 素材类别列表
export function matterTypeList() {
    return ajax.post(`${apiEnv.api2}/crm/option/courseMedia`)
}
// 领域下拉
export function dominList() {
    return ajax.post(`${apiEnv.api2}/crm/option/prodDomains`)
}
// 产品下拉
export function productSelectList(data) {
    if(data){
        return ajax.post(`${apiEnv.api2}/crm/option/productSelect?productDomainId=${data}`)
    }else {
        return ajax.post(`${apiEnv.api2}/crm/option/productSelect`)
    }
}
// 多领域下的产品下拉
export function productSelectByDomains(data) {
    if(data){
        return ajax.post(`${apiEnv.api2}/crm/option/productSelectByDomains?productDomainIds=${data}`)
    }else {
        return ajax.post(`${apiEnv.api2}/crm/option/productSelect`)
    }
}
// 品牌下拉
export function brandList() {
    return ajax.post(`${apiEnv.api2}/crm/option/brandSelect`)
}
//行业下拉
export function industryList() {
    return ajax.post(`${apiEnv.api2}/crm/option/industrys`,{lvl:1})
}
//难度下拉
export function difficultyLevelList() {
    return ajax.post(`${apiEnv.api2}/crm/option/difficultyLevel`)
}
//详情列表
export function matterDeatil(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/courseMedia/details`,data)
}
//素材提交
export function submitMatter(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/courseMedia/addOrModi`,data)
}
//删除素材
export function delCourseMedia(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/courseMedia/del`,data)
}




//课程管理列表
export function courseList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/courseManage/list`,data)
}
// 课程类别下拉
export function courseTyeList() {
    return ajax.post(`${apiEnv.api2}/crm/option/courseType`)
}
//角标
export function courseManageCount() {
    return ajax.post(`${apiEnv.api2}/gz/admin/courseManage/count`)
}
//课程管理详情
export function courseManageDetail(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/courseManage/details`,data)
}
// 认证情况下拉
export function authenticationList() {
    return ajax.post(`${apiEnv.api2}/crm/option/authentication`)
}
// 收费条件下拉
export function chargeTypeList() {
    return ajax.post(`${apiEnv.api2}/crm/option/chargeType`)
}
//考试列表
export function examList(data) {
    return ajax.post(`${apiEnv.api2}/exam/list`,data)
}
//删除or恢复
export function recoverOrDel(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/courseManage/recoverOrDel`,data)
}
//发布or取消发布
export function publishApi(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/courseManage/publish`,data)
}
//新增课程
export function courseManageAddOrModi(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/courseManage/addOrModi`,data)
}
//试卷分类
export function courseAttribute(data) {
    return ajax.post(`${apiEnv.api2}/crm/option/attribute`,data)
}
//试卷类别
export function paperCategoryApi() {
    return ajax.post(`${apiEnv.api2}/crm/option/paperCategory`)
}
// 视频格式下拉
export function mediaFormatList() {
    return ajax.post(`${apiEnv.api2}/crm/option/mediaFormat`)
}





//课程订单列表
export function courseOrderList(data) {
    return ajax.post(`${apiEnv.api2}/gz/admin/courseOrder/list`,data)
}
export function downloadCourseOrder(data) {
    return ajax.get(`${apiEnv.api2}/gz/admin/courseOrder/download`,data)
}